import { useId } from "react";
import {
  DOT_GRID_CROSS_PATH,
  DOT_GRID_POINTS,
  DOT_GRID_RADIUS,
  DOT_GRID_TILE,
} from "./IlluDotGrid.logic";
import styles from "./IlluDotGrid.module.css";

type Props = {
  className?: string;
};

export function IlluDotGrid(props: Props) {
  const { className } = props;
  const patternId = useId();

  return (
    <svg className={`${styles.grid} ${className ?? ""}`} aria-hidden="true" focusable="false">
      <defs>
        <pattern
          id={patternId}
          width={DOT_GRID_TILE}
          height={DOT_GRID_TILE}
          patternUnits="userSpaceOnUse"
        >
          {DOT_GRID_POINTS.map((point) => (
            <circle
              key={`${point.x}-${point.y}`}
              className={styles.dot}
              cx={point.x}
              cy={point.y}
              r={DOT_GRID_RADIUS}
            />
          ))}
          <path className={styles.cross} d={DOT_GRID_CROSS_PATH} />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${patternId})`} />
    </svg>
  );
}
